(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tn-card-stepper')) {
  customElements.define('tn-card-stepper', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.select = this.querySelector('select[name="options[Number of cards]"]');
      this.input = this.querySelector('.tn-step-row input');
      this.dropdown = this.querySelector('.tn-card-dropdown');
      if (!this.select || !this.input) return;
      this.rows = JSON.parse(this.querySelector('[data-card-prices]').textContent).sort((a,b)=>a.n-b.n);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'});
      this.ready = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-step]');
        if (!button) return;
        event.preventDefault();
        this.choose(Number(this.input.value) + Number(button.dataset.step));
      });
      this.input.addEventListener('change',()=>this.choose(Number(this.input.value)));
      this.dropdown.addEventListener('change',()=>this.choose(Number(this.dropdown.value)));
      this.input.addEventListener('keydown',(event)=>{
        if(event.key==='Enter'){event.preventDefault();this.choose(Number(this.input.value));}
      });
      this.select.addEventListener('change',()=>this.paint(Number(this.select.value)));
      this.querySelector('.tn-step-ui').hidden = false;
      this.classList.add('tn-ready');
      this.paint(Number(this.select.value));
    }
    choose(value) {
      this.select = this.querySelector('select[name="options[Number of cards]"]');
      if (!this.select) return;
      const n = Math.min(20,Math.max(1,Math.round(Number.isFinite(value)?value:1)));
      const row = this.rows.find(r=>r.n===n);
      const option = Array.from(this.select.options).find(o=>Number(o.value)===n);
      if (!row || !option) return;
      this.paint(n);
      if (this.select.value !== option.value) {
        this.select.value = option.value;
        this.select.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }
    paint(n) {
      const row=this.rows.find(r=>r.n===n) || this.rows[0];
      this.input.value=String(row.n);
      this.dropdown.value=String(row.n);
      this.querySelector('[data-step="-1"]').disabled=row.n<=1;
      this.querySelector('[data-step="1"]').disabled=row.n>=20;
      this.querySelector('[data-total]').textContent=this.money.format(row.price/100);
      this.querySelector('[data-each]').textContent=this.money.format(row.price/row.n/100);
      const base=this.rows.find(r=>r.n===1).price;
      const saved=Math.max(0,base*row.n-row.price);
      this.querySelector('[data-save]').textContent=this.money.format(saved/100);
      this.querySelector('.tn-step-save').hidden=saved===0;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
